import { render, staticRenderFns } from "./EmployeeInviteEditModal.vue?vue&type=template&id=4c63b3a7"
import script from "./EmployeeInviteEditModal.vue?vue&type=script&lang=js"
export * from "./EmployeeInviteEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports